import PropTypes from "prop-types";
import { useState } from "react";
import submit from "submit-form";
import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import getAvatarUrl from "../../../../utils/get-avatar-url";

export const NewMessageModal = ({ locals }) => {
  const { t } = useTranslation("coaching-portal");
  const { activeUser, activeCommunityChatClientsList: subscribers = [] } =
    locals;

  const { webAppTheme = "dark" } = activeUser;
  //store the filter value
  const [filterValue, setFilterValue] = useState("");
  //array of filtered users
  const filteredUsers = filterValue
    ? subscribers.filter((user) =>
        user.name.toLowerCase().startsWith(filterValue.toLowerCase())
      )
    : subscribers;

  const getChatType = ({ isMember, isPerform, isPull }) => {
    if (isMember) return "press";
    if (isPerform) return "perform";
    if (isPull) return "pull";
    return "push";
  };

  const sendMessage = (e, user) => {
    e.preventDefault();

    submit(`/actions/user/check-chat-users/${user._id}/${getChatType(user)}`, {
      method: "POST",
      body: {},
    });
  };

  return (
    <Modal className="add-new-message-modal" title={t("communityChat.newMessageModal.title")}>
      <div className="body">
        <input
          placeholder={t("communityChat.newMessageModal.searchAthletePlaceholder")}
          value={filterValue}
          onChange={({ target: { value } }) => setFilterValue(value)}
          type="search"
        />
        <div>
          <div className="edit-channel-cards-container">
            {filteredUsers.length === 0 && filterValue.length > 0 ? (
              <div className="empty-filter-chat-state">
                <p className="s1">{t("communityChat.newMessageModal.noUsersFound")}</p>
              </div>
            ) : (
              filteredUsers.map((user) => {
                const { email = "", name = "", _id = "" } = user;
                return (
                  <button
                    className="edit-channel-cards"
                    key={_id}
                    onClick={(e) => {
                      sendMessage(e, user);
                    }}
                    type="button"
                  >
                    <div className="edit-channels-info-container">
                      <div
                        className={"avatar-group-chat"}
                        style={{
                          background: `url(${getAvatarUrl(
                            user,
                            false,
                            webAppTheme
                          )})`,
                          backgroundPosition: "center center",
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                        }}
                      ></div>
                      <div className="identifier-group-chat">
                        <span className="name-group-chat">{name}</span>
                        <span className="role-group-chat">{email}</span>
                      </div>
                    </div>
                  </button>
                );
              })
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

NewMessageModal.propTypes = {
  locals: PropTypes.object,
};
